import { capitalize } from 'lodash';
import { dateToLabel } from 'further-ui/utils';
import { loadPdfMake } from './pdfMakeLoader';

const checkImage =
  'data:image/png;base64,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';

const userImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAmpJREFUWIXtl09IVUEUxk9mkorRImwRBgVui1JC4kVCoVQSEVRQq/7QIlpVLoInvp1U0C5aFCS5iDZSpBao5aJlm4oCVy6kKMhKN/3PvsN8l/d8zlxn7hto4wc/eNxzvjPn3Tt3Zq7IshZqBbgDfoJ58rqCeq9K6mjNfo7hVCuTp8AzctORuw7sII2OnBsldaZYuzWtgXYm9Tri2v0J8AL8leK/U16Ck6DK4S0wb3fWBtaAx4z/4O+rZBh8Z2wUrM3aQAuTLpZdXwUmGBsCGy3eDeAhc56DmrL4BcZa0hpQbbOYL9N8H6xM8ertv8fcfFmshrWDtRrMgI9iHsNSagAfwBdQm2XAcnWK+UdXAjx99OyL0UDy7A4FeA7ScylGA3kW2xvg2UNPT4wGTrHY2QDPaXrOxGigWYrvt6+G6WmO0YBqnAUPeOR2iFkln8YaXLUFfANfxayWLu0Cn8WsiluzDLQJfALHLLHDYpbg3+C8JX6OMd31jljiR8WsJ5vTGmiX9M1oP/gFpi2xaca6HN6CVLgZ6cyeYXzQEh9kTB+B7Y3xaiDHJJ10eXIc3OV1baAb1Fm8dYwlTQ7QWyATvJ5La0CLTMrCfT5Bm1qfZqY0Z8xRY9LR/KIm9DbpajZC4yNZvEOmSXOTrXmI9XI+g5dqu5hZ/RbUhxgp9bxhjSXPADbpyqcLys4sZqqNNcZDjbqIJLe+Uj1graDDyDWJt58n54nrISb9FpiTsInnkp4nZ8XMBy/pTP0jcTeTUdb0msxNYm7ZO/DEgzEP3rOm7TRt1S0xr49tMcmC1rrtO3giPWJXR8L1tfT/9Q/JNcknEvdv7wAAAABJRU5ErkJggg==';

const idImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAARVJREFUWIVjYBgFo2AUIEAaED8E4hc0wk+AuAWfA54C8UwgjqcRbgbif0DMhcsBr4E4EohZgTgTiAvwYC0s+lWAeAsQn0DCx4F4OhCzAbEZEP8HYn5CDhAH4jNAfBkPTsGifwYQXwLiejT8A4h9SHEACHAAMQ8SZsWlCQksAeKFWMTfAnE4KQ6QBeLfUMUwfI2eDgABEyC2RsKq9HYAOWDAHTAbiM8BcQka/g7EfvRwgCYQH2BAzS2gXLGYAZKoae4AQoAkB4AUiVAJC5HqAFA2/MuAmg0pxU6khgAoPvWphPWAmIlUB9ACEHQAqPy/x4BamVATg0rTN0DMgssB8kBcBsTVNMKVQKxLMJxGwSgYBaOA3gAAMJqqOgq7jxAAAAAASUVORK5CYII=';

const faceImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAU9JREFUWIXtl09OwkAUxgcSNqxkAbJWJBFCN7BFdOEFFNbCCeAaJECklyAQjKeCU2Dwe/F1UzqvM5WxTeRLfknTvj9fp53OVKmLTuWBQQQ1ixp3mhpeXOICHDW8WxhYCnXmuiSPA95AzqKZqajmkHu0ogIGfNFF80B57tGXDLjWkXtdDGTPAM1zm6mWVF/gJUliDxQN4oocq9ODYZ0TmTp/BYckDeKkfXYhOXuX9uDRIO4J7FwYCKsD2n/RSKdghUtNNNTjNA3QwrICE3DtulmJiTJBI1EJnb9izqZb8AEKBrEU8wlubJvQNmopXKc73YCyEEMjQUafhRhfabZ3Jh+QOliDKeiCKtPlc1twH1PjLKthQ/28fD5Dx03D3Owux5kxkNqmNNiWDznQRfORErblpLnS/1BIUzQsX6gzi0smdzREv/k1q0Xk95Vw5/9X33YqXen6FEnOAAAAAElFTkSuQmCC';

const eyeImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAjxJREFUWIXtlc1LlUEUxs9VM9GgIBASV7ZJC5KIMr82dWlntEz8WBQluAjddDcmRoSiKG4KxBYtJAPBgor6C1JqIaER1UJFVCr7QCKMtJ6Hcy7cXucdPzIweB/4weXOmfc5c2bmjEikSJH+Q6WBQnAWXAIXwRlQ8C9Nd5jhXbAAfoUwCbpB0VYZ7wJXwKwZjIFrIA72gXQjH1SBm+A9WAEPwZG/Ma8x4x/gNji8znk7QT14A5ZBH9izEWMGD4uu+D7Y74g5CgbAW/AODIKSQAy3rQksgmlQsR5zlnUcfAXnQmIawE/RFfaI7vlr0dVedsTzcD4TreQFn3m26B6z7IdCYo6Z+S2QkfI/z0GvJVHumJcpuo08G41hCdwA30GxJ8l7oqvNcIzxer4U3TaXYilJxl2Teb26PObUJOj0jF8Hc55x+jwR3b5Y6gCvm7c8pinQ4RnnFZ1f4xvN5rXqZgyBD+CAZzJvB8uc5hjjil6AR575J8E30O8a3AteiTaSspAPVIpm3y5/lpC/20Sv7qr9NbFlL4luQVZYhrlgRPTKJERPd1AJS4KrbQUtYNTMWx3xXNigjfMmZIaZJ8VOljytz8EJRwxL+Rh8FD28T8HpQAyTPy9a0c+gbi3joNi52Be42gcSvi1BsQNWgwmbywcsb6PmSXEVNfYxlpBd8iooBTkpcbvBKdHOOGfGrNDxzRoHxUPGst8BnywZmnwxks/xjCVxcKuMXWIX5DPLFy9h1JppzDMvUqRI21O/AXpbf9KTh5EDAAAAAElFTkSuQmCC';

const nameImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAP9JREFUWIVjYBgFo2AQglU0xgTBfxrjAXXAP2IcMApGAbkJjKgsRk8H5APxMyCuJ9UB5BYwhUhmCADxV6jDfgKxOKmOoBTkMqCGTiW9HXAFzQH3gJiJWM3kBDkysEGy+BcS24NYB1Ca6hcjqUGOivXUdsBKLHqFgfg7VP4KVOwElP8biKWJdQS5oIgB1fcgkIgkVkdLyxmB+AaSZTsYING0BUnsERAzEzIolADGBRwZiIs6X0IOILdBsYJIB2yhhQNEGSAlHkj+PA41h6Hyf4BYDp8D8AV/CA49OkgOTMehJhpJjSk+B5ALIhggKZ8FhzyoJEwD4ihaWD4KRgHZAAAhWuR3eEkg+QAAAABJRU5ErkJggg==';

const checkIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAsZJREFUWEftlVtIFFEYx7+ZOdPeht2d2VuYIpVpmhqVgUER1KI+RPRWPvQU+VBE5Q2yQDGjexkWiRD10ktLPRVRqD1IIciiuF56sCjC0hl39tbq7pzdnZggEG+7q64+tOf1+87//+PPOd9HwDofYp39IQ2QTiCdwP+RQOZF0GQZOAdBUtwnl3AAHBD9N39SnsCeKqDpDPMrtVp1JBqN/pj+PrHV2QF4bQCagCwF7rlarTkRi8UEkXcfHGqVRmdP31QmQOxtZNt1Gm1VLCb7PG7hsOsuds4d/SkDKLnC3mIYbZ0sy9MeUawYvB3qWWjvpASgpMFwmdEzLTLIkuhxH3PdDL9dbOmtOsDuBuasXm94CCBHvV5P5cCNGcdSG3ceQGkT9wJIUjclTFWOtYE/mXW965LupN5gfEYAED6f/3T/9cCTePfnAexvsY0ihLZLYdw7Mc5XfO0AXzwRpV5Urz1m4owOAAL5At6a/mvBe4ncmweQX6PONrHGboSoLZIk9QV+CeWux+BZSqyoVm03mbnXAIQqEAw0O6/6GxMxV3oWfAOF1ZosljN0U4jKwRg7vSJfNnwfxIVEi2rRPs5kfU8QBBP4HXzgbPFeSNR8UQClUFyvydTrDV0IUbkY4wH3BG///Ajcs8V3VNM7TWbLB5Ik2OD0zNO+ZvEUAMirAqCI5NVrMyx6phshOg9jPDjJ8/axNhCUWn6dapuFZXtIkrKFQjMve4fF47NnfKIQcb9hwRnYyGXYuhBCBZEIHhoXeLuO0mxgzYYeiqSyw+HQO5/sPjrSBFKipkmP4s3nwbbJYu1EiC6MRCIjADL1NxVJ+hjwC+WDdyC4HPMl38BcwZxzYLFZrZ00TRcrNYxx/7ibP/StFbzLNU8KQGnOrQGz1Wh9E5NBNfmTL/vSDvxKzJMGWKnZmi2jZEDj/oJkxJbTmwZY9wT+AE1B8iHcPAt9AAAAAElFTkSuQmCC';

const warningIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAABC5JREFUWEfNl19s01UUxz/3127rQBdmRJyJisynolFQMzdfjLoXedKoEyJqjA74dVVHMKjBcgeEgERH6PpjbGqIhmAw6NN4UDG++AcVNqfOF2ZQEyWAYjCWjba/6+7tr0vdOnotarxPTXrO+X7vOed37vcILI90uQjB3SjuABYD84E5gftvwDEEg0LxQWSMA2tf43eb0KKc0cYOrsn5rAUeAmaXsw/+/wPBHny2yp18dz6fGQnsiFPza5YEDmtQVAM54EMBAwoOVVUxmvmJ0zp41RXUZzI0CmhSsGTC7nYghOAc8NIlDl1PJhkvRaQkgU0xrs4q3g5SnQH68dkmezlmkwHjD8+gaNf8gEF87i3lP43AhhgLfcV7QAOKL50QyxM9fGUDPNVGruQ6HN4AbgSO49Mqe/m62O4vBIKbfxKA76+LsHx1N2crAS/4vNxJ7ZlxXgfuC0g0F2dikoCpeQ4NvgjF/ugp2h54y9T9gs+++wmNzOXNgMQQaZrlbsZ04EkCMsZmFM8BQ3U1tNjcXLq0OA4i0cNH5VgGmfg4KMcW6RmsPAG5igU4fItCOA432dZcuqSNv8escgSMXb4njiBQIYfoC0lG8wRi7DIdK0jJFB02wYyfiwoIlJ0nhZjSJQkGo196tIutj3Hx2Qg/A5GwoHFdiu//VQLtXEXYDKfx2jEuF10ubQrTIO9Lj1Zb8EozEPjpz/wuBEtFIf0CVq/36P5PCMR4GmWw+oV0+Ry4GbhNeugutT6V9IAOviFGs68M1heawEngUnzmyV5OWKNX2IQ6/uY4c8/lDNYpTUDP+nBDluoVfea39ak0A8FgyuoH7n9BwJSgOsRlzydNOaxPpRkoKsEvk03oCFoSKfMWWJ9KCchV3IowWIc1gT7gCQSdMsV2a/R8Ex7W41x6RqJZny6XpxRsR/GKngMPothbySCyRpxiOPGIvQu0ClhWGMXHgRqyLJB9/FBpYBs/WTSKCdGQf4wKZYAe6RG3CRT4fRaU4BZrnxg7UAbjVenxuCGwMU5jzmfEPMeCRYkU39gE/Ls9IFcQJcygia1YKD2OFguSLSgjvwdJ01JQLDZEbGzko0SYZYSLbtgXpWewihSRNqjlUwQ3APuiJ1n2D0uyPUAbMEyapmmSzJQiv4To73OeJkGaRy40E8HNdwfgJ1A0Fy8r02V5B9f7vpHlmsQRR/CwbU9MLYWpecjIcp12Dd4qdzJcbFdSSplM5HjHlCO/3ewKK7at8/jRpt6bXK7MwhoEK4Otanhix7in1Jo2o5YzqZuNBDqLVrODCAYcOORnGI2ezq9mI/XUO1U0+tCEMqvZnWY1w7yu3aRZP1Mpy4pJ6XIt8CywdKJ7rdQvGLWsp6uW30fPl7WyBArOMk6dyLFE6fVcsBjBfJRZz7Uyzq/nMCTgoAoxIJOcsSnXn6T6mpRPCBimAAAAAElFTkSuQmCC';

const failIcon =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAo5JREFUWIXt1UtoVFcAxvHf5IFJJjpjBl+xmlFMW1I7CCKi3bjRpi2IVrSgCy1Ig/ZB240UMSAoggsfRIUGRDfaIrRQ3HRhUSQWbE00NvGFD4yGwQRRG21oE3O7UXGRmbkTXQjOf33O9/3PueecS4ECBV5xihZQ9oIZkXmUZyzINnM2c2bQtIzaEZYXrWBBLTtHJICuSlLVNC8hiUge5cWrWTqFpjIeZByULSHNw8m0xFgYZ9lUWi/QE6Z8FYvHs+sRv37PBgzlLQAXuTuO43E+ivHJNP7oyCIxm9IPWD2exj4OXmPbdf7JaBpiNa7QV03LGOaPZmUN7Z2kh8urZ1WCzX9zqJmt1+nPlh1KAC5xv5JjCd6Ls3Y6nX9xCwHMo7yeL6v45h47ztKU5t9cuaEF4Ab9b3AqSirGmiQXOuhCySLWj+Xb++zdz94w5eR3qp+RIjqf7RUsuktjOTMrWd7L5g6OtDIQNiuvHXjKHQZinI6TrOLrUt69x5YDHEozmE9WrncgIyUEQwxFEBAEGa5ZLka0AymiKbZGqe/hu4A7MRpq6S3hcjoPmbwFPmRiil0VzL3F54c5eoYT71BcReNYBtv405Pb8VIF3qdqBrtHMauHr37g5JOioVGcixOMYV0dA2V03A5xHkILfExNkj2lJNOsO8zvnlvlbQZbOf0WfQk2xalopUWOzxFGILKY6ik0lzCpm4YjtBl+i4MBOhM8iNNQx+gJtF/N8ibkFFjKm0n2FRG9yfqfOJ+hHPTy+Czt0+lOsLGCSWc4ZiQ/ozlMnMmPEYqu8ekvXM5W/hzBea68TVectXVUt/HbcAOzvgPF1PRz8SafHeVGyPKnPD7Az9188R+JPOYVKPCa8T8ngLXqrbUm4wAAAABJRU5ErkJggg==';

const addressImage =
  'data:image/png;base64,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';

type CheckDetails = {
  approved?: boolean;
  results?: Array<{
    status?: string;
    recommendation?: string;
    reason?: string;
    breakdown?: Array<{
      subCheck?: string;
      result?: string;
      details?: Array<{
        value?: string;
        name?: string;
        caDocId?: string;
        reasons?: Array<string>;
        countryNames?: Array<string>;
      }>;
    }>;
    watchlistSummary?: {
      totalHits?: number;
      associatedCountryCodes?: Array<string>;
      searchConfig?: {
        clientRef?: string;
        sources?: {
          type?: string;
        };
      };
      rawResults?: Array<Record<string, string | Record<string, string>>>;
    };
  }>;
};

type KycData = {
  createdAt?: string;
  detailsMatch?: boolean;
  documents: Array<{
    documentId?: string | null;
    documentType?: string | null;
    issuingCountry?: string | null;
    extractedDocument?: Record<string, string | Record<string, string>>;
  }>;
  sessionId?: string;
  investorId?: string;
  yotiStatus?: string;
  livenessCheck?: CheckDetails;
  documentAuthenticityCheck?: CheckDetails;
  faceMatchCheck?: CheckDetails;
  thirdPartyIdentityCheck?: CheckDetails;
  amlCheck?: CheckDetails;
};

const downloadKycPdf = async (
  kycData: KycData,
  kycImages: {
    livenessCapture?: Array<{ content?: string }>;
    documents?: Array<Array<{ content?: string }>>;
  },
  investorDetail?: { fullName?: string },
) => {
  const {
    createdAt,
    detailsMatch,
    documents,
    sessionId,
    investorId,
    livenessCheck,
    documentAuthenticityCheck,
    faceMatchCheck,
    thirdPartyIdentityCheck,
    amlCheck,
    yotiStatus,
  } = kycData ?? {};

  const addressCheckHasPepOrSanctionsFailure =
    thirdPartyIdentityCheck?.results?.some((result) =>
      result.breakdown?.some(
        (item) =>
          (item.subCheck === 'pep_warning' ||
            item.subCheck === 'sanctions_warning') &&
          item.result !== 'PASS',
      ),
    ) ?? false;

  const livenessCaptureRows: Array<Array<{ content?: string }>> = [];
  for (let i = 0; i < (kycImages.livenessCapture?.length ?? 0); i += 3) {
    //@ts-expect-error
    livenessCaptureRows.push(kycImages.livenessCapture?.slice(i, i + 3));
  }

  const getWatchlistSummary = (
    checkResults: Array<{
      watchlistSummary?: {
        totalHits?: number;
        associatedCountryCodes?: Array<string>;
        searchConfig?: {
          sources?: { type?: string };
          clientRef?: string;
        };
      };
    }>,
  ) => {
    return (
      checkResults.find((result) => !!result.watchlistSummary)
        ?.watchlistSummary ?? {}
    );
  };

  const getDocumentImageRows = (documentIndex: number) => {
    const documentImageRows: Array<Array<{ content?: string }>> = [];
    for (
      let i = 0;
      i < (kycImages.documents?.[documentIndex]?.length ?? 0);
      i += 2
    ) {
      documentImageRows.push(
        //@ts-expect-error
        kycImages.documents?.[documentIndex]?.slice(i, i + 2),
      );
    }
    return documentImageRows;
  };

  const getExtractedData = (
    extractedData: Record<string, string | Record<string, string>>,
  ) => {
    return Object.keys(extractedData).map((label) => {
      const value = extractedData[label];

      return {
        label: capitalize(label.replaceAll('_', ' ')),
        value:
          value && typeof value === 'object'
            ? Object.keys(value).map(
                (key) =>
                  `${capitalize(key.replaceAll('_', ' '))}: ${value[key]}`,
              )
            : value,
      };
    });
  };

  const getBreakdownLabel = (label: string) =>
    label === 'pep' ? 'PEP' : capitalize(label);

  const getBreakdownValues = (
    breakdown?: Array<{
      subCheck?: string;
      result?: string;
      details?: Array<{ name?: string; value?: string }>;
    }>,
  ) =>
    breakdown?.length
      ? breakdown?.map((data) => ({
          label: getBreakdownLabel(data.subCheck?.replaceAll('_', ' ') ?? ''),
          value: data.result,
          color: data.result === 'PASS' ? 'green' : 'red',
          icon: data.result === 'PASS' ? checkIcon : failIcon,
          details:
            data.details
              ?.filter((detail) => detail.name)
              .map((detail) => `${detail.name}: ${detail.value}`) ?? [],
        }))
      : null;

  const overviewValues = {
    'Session ID': sessionId,
    'User ID': investorId,
    Started: dateToLabel(createdAt, 'N/A', true),
    Status: capitalize(yotiStatus),
  };

  const getRecommendation = (
    checkResults?: Array<{ recommendation?: string }>,
  ) => {
    return (
      checkResults?.find((result) => !!result.recommendation)?.recommendation ??
      '-'
    );
  };

  const recommendationValues = [
    {
      image: userImage,
      name: 'Liveness capture',
      value: livenessCheck?.approved
        ? 'Approve'
        : getRecommendation(livenessCheck?.results ?? []),
      color: livenessCheck?.approved ? 'green' : 'orange',
      icon: livenessCheck?.approved ? checkIcon : warningIcon,
    },

    {
      image: idImage,
      name: 'Document authenticity',
      value: documentAuthenticityCheck?.approved
        ? 'Approve'
        : getRecommendation(documentAuthenticityCheck?.results ?? []),
      color: documentAuthenticityCheck?.approved ? 'green' : 'orange',
      icon: documentAuthenticityCheck?.approved ? checkIcon : warningIcon,
    },
    {
      image: faceImage,
      name: 'Face match',
      value: faceMatchCheck?.approved
        ? 'Approve'
        : getRecommendation(faceMatchCheck?.results ?? []),
      color: faceMatchCheck?.approved ? 'green' : 'orange',
      icon: faceMatchCheck?.approved ? checkIcon : warningIcon,
    },
    {
      image: nameImage,
      name: 'Name match',
      value: detailsMatch ? 'Approve' : 'Consider',
      color: detailsMatch ? 'green' : 'orange',
      icon: detailsMatch ? checkIcon : warningIcon,
    },
    ...(thirdPartyIdentityCheck
      ? [
          {
            image: addressImage,
            name: 'Address match',
            value: thirdPartyIdentityCheck?.approved
              ? 'Approve'
              : getRecommendation(thirdPartyIdentityCheck?.results ?? []),
            color: thirdPartyIdentityCheck?.approved ? 'green' : 'orange',
            icon: thirdPartyIdentityCheck?.approved ? checkIcon : warningIcon,
          },
        ]
      : []),
    {
      image: eyeImage,
      name: 'AML advanced screening',
      value: amlCheck?.approved
        ? 'Approve'
        : getRecommendation(amlCheck?.results),
      color: amlCheck?.approved ? 'green' : 'orange',
      icon: amlCheck?.approved ? checkIcon : warningIcon,
    },
  ];

  const getCheckDetailsTable = (
    check: CheckDetails | undefined,
    checkType: string,
  ) => [
    [
      { text: 'Check details', style: 'tableSubheader' },
      { text: 'Breakdown', style: 'tableSubheader' },
    ],
    ...(check?.results?.map((result) => [
      {
        columns: [
          {
            width: 95,
            style: 'checkDetails',
            stack: [
              { text: 'Type', bold: true },
              { text: 'Status', bold: true },
              { text: 'Recommendation', bold: true },
              { text: 'Reason', bold: true },
            ],
          },
          {
            style: 'checkDetails',
            stack: [
              checkType,
              result.status ?? '-',
              result.recommendation ?? '-',
              {
                text: result.reason?.replaceAll('_', ' ') ?? '-',
                style: 'reasonText',
              },
            ],
          },
        ],
      },
      {
        layout: 'noBorders',
        table: {
          widths: ['80%', '20%'],
          body: getBreakdownValues(result.breakdown ?? [])?.map((breakdown) => [
            [
              { text: breakdown.label, bold: true, margin: [0, 3, 0, 0] },
              ...(breakdown.details.map((details) => ({
                text: details,
                fontSize: 10,
              })) ?? []),
            ],
            [
              {
                alignment: 'right',
                columnGap: 4,
                columns: [
                  {
                    text: breakdown.value,
                    color: breakdown.color,
                    margin: [0, 3, 4, 0],
                  },
                  { width: 15, image: breakdown.icon },
                ],
              },
            ],
          ]) ?? [[], []],
        },
      },
    ]) ?? []),
  ];

  const pdfMake = await loadPdfMake();
  pdfMake
    .createPdf(
      {
        pageMargins: [40, 110, 40, 60],
        header: [
          {
            margin: [40, 30, 40, 20],
            stack: [
              {
                columns: [
                  {
                    width: 15,
                    image: checkImage,
                  },
                  { text: 'Identity Verification Session', style: 'header' },
                ],
                marginBottom: 15,
              },
              {
                marginLeft: 20,
                marginBottom: 5,
                columns: [
                  {
                    width: 100,
                    text: 'Organisation name:',
                    style: 'headerAppInfo',
                  },
                  { width: 'auto', text: 'Further', style: 'headerAppInfo' },
                ],
              },
              {
                marginLeft: 20,
                columns: [
                  {
                    width: 100,
                    text: 'Application name:',
                    style: 'headerAppInfo',
                  },
                  { width: 'auto', text: 'Further', style: 'headerAppInfo' },
                ],
              },
            ],
            columnGap: 6,
          },
        ],
        footer: (currentPage) => {
          return {
            columns: [
              `Session ID: ${sessionId}`,
              { text: `Page ${currentPage}`, alignment: 'right' },
            ],
            style: 'footer',
          };
        },
        pageBreakBefore: (currentNode) => {
          return (
            currentNode.id === 'livenessCapture' ||
            currentNode.id === 'livenessCaptureImages' ||
            currentNode.id === 'document' ||
            currentNode.id === 'amlCheck' ||
            currentNode.id === 'nameCheck' ||
            currentNode.id === 'thirdPartyIdentityCheck' ||
            currentNode.id === 'documentExtraction'
          );
        },
        content: [
          {
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Overview',
                    style: 'tableHeader',
                  },
                ],
                ...Object.keys(overviewValues).map((key) => {
                  return [
                    {
                      stack: [
                        { text: key, style: 'overviewLabel' },
                        overviewValues[key],
                      ],
                    },
                  ];
                }),
              ],
            },
          },
          {
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Recommendations',
                    style: 'tableHeader',
                  },
                ],
                ...recommendationValues.map((value) => [
                  {
                    columns: [
                      {
                        width: 24,
                        image: value.image,
                      },
                      {
                        width: '*',
                        text: value.name,
                        margin: [25, 5, 0, 0],
                      },
                      {
                        width: 100,
                        margin: [0, 5, 0, 0],
                        text: value.value,
                        color: value.color,
                        alignment: 'right',
                      },
                      {
                        width: 16,
                        image: value.icon,
                        margin: [10, 3, 0, 0],
                      },
                    ],
                    margin: [0, 0, 10, 0],
                  },
                ]),
              ],
            },
          },
          {
            //@ts-expect-error
            id: 'livenessCapture',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Liveness capture',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: userImage,
                      },
                      {
                        width: '*',
                        text: 'Liveness capture',
                        margin: [25, 9, 0, 0],
                      },
                      {
                        width: '*',
                        text: `${
                          kycImages.livenessCapture?.length ?? 0
                        } images collected`,
                        margin: [0, 9, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Checks performed',
                    style: 'containerTableHeader',
                  },
                ],
                [
                  {
                    style: 'breakdownTable',
                    layout: 'greyBordersChild',
                    table: {
                      widths: ['50%', '50%'],
                      body: getCheckDetailsTable(
                        livenessCheck,
                        'Static liveness',
                      ),
                    },
                  },
                ],
              ],
            },
          },
          {
            //@ts-expect-error
            id: 'livenessCaptureImages',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Liveness capture',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: userImage,
                      },
                      {
                        width: '*',
                        text: 'Liveness capture',
                        margin: [25, 9, 0, 0],
                      },
                      {
                        width: '*',
                        text: `${
                          kycImages.livenessCapture?.length ?? 0
                        } images collected`,
                        margin: [0, 9, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Collected images',
                    style: 'containerTableHeader',
                  },
                ],
                ...livenessCaptureRows.map((row) => [
                  {
                    columns: row.map((image) => ({
                      width: 182,
                      stack: [
                        {
                          image: image?.content,
                          width: 150,
                        },
                      ],
                    })),
                  },
                ]),
              ],
            },
          },
          (documents ?? []).map((document, index) => [
            {
              id: 'document',
              style: 'table',
              layout: 'greyBorders',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: `ID document ${index + 1}`,
                      style: 'tableHeader',
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          width: 32,
                          image: idImage,
                          margin: [0, 12, 0, 0],
                        },
                        {
                          width: '35%',
                          margin: [25, 0, 0, 0],
                          style: 'checkHeaderDetailsLabels',
                          stack: [
                            'Document ID',
                            'Document type',
                            'Issuing authority',
                          ],
                        },
                        {
                          width: '*',
                          style: 'checkHeaderDetails',
                          stack: [
                            document.documentId,
                            document.documentType,
                            document.issuingCountry,
                          ],
                        },
                      ],
                    },
                  ],
                ],
              },
            },
            {
              style: 'table',
              layout: 'container',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: 'Checks performed',
                      style: 'containerTableHeader',
                    },
                  ],
                  [
                    {
                      style: 'breakdownTable',
                      layout: 'greyBordersChild',
                      table: {
                        widths: ['50%', '50%'],
                        body: getCheckDetailsTable(
                          documentAuthenticityCheck,
                          'Authenticity',
                        ),
                      },
                    },
                  ],
                  [
                    {
                      style: 'table',
                      layout: 'greyBordersChild',
                      table: {
                        widths: ['50%', '50%'],
                        body: getCheckDetailsTable(
                          faceMatchCheck,
                          'Face match',
                        ),
                      },
                    },
                  ],
                ],
              },
            },
            {
              id: 'documentExtraction',
              style: 'table',
              layout: 'container',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: 'Text extraction',
                      style: 'containerTableHeader',
                    },
                  ],
                  [
                    {
                      style: 'table',
                      layout: 'greyBordersChild',
                      table: {
                        widths: ['50%', '50%'],
                        body: document.extractedDocument
                          ? [
                              ...getExtractedData(
                                document.extractedDocument,
                              ).map((data) => [[data.label], [data.value]]),
                            ]
                          : [[], []],
                      },
                    },
                  ],
                ],
              },
            },

            {
              id: 'document',
              style: 'table',
              layout: 'greyBorders',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: `ID document ${index + 1}`,
                      style: 'tableHeader',
                    },
                  ],
                  [
                    {
                      columns: [
                        {
                          width: 32,
                          image: idImage,
                          margin: [0, 12, 0, 0],
                        },
                        {
                          width: '35%',
                          margin: [25, 0, 0, 0],
                          style: 'checkHeaderDetailsLabels',
                          stack: [
                            'Document ID',
                            'Document type',
                            'Issuing authority',
                          ],
                        },
                        {
                          width: '*',
                          style: 'checkHeaderDetails',
                          stack: [
                            document.documentId,
                            document.documentType,
                            document.issuingCountry,
                          ],
                        },
                      ],
                    },
                  ],
                ],
              },
            },
            {
              style: 'table',
              layout: 'container',
              table: {
                widths: ['100%'],
                body: [
                  [
                    {
                      text: 'Document media',
                      style: 'containerTableHeader',
                    },
                  ],
                  ...getDocumentImageRows(index).map((row) => [
                    {
                      columns: row.map((image) => ({
                        width: 270,
                        stack: [
                          {
                            image: image?.content,
                            width: 220,
                          },
                        ],
                      })),
                    },
                  ]),
                ],
              },
            },
          ]),

          {
            //@ts-expect-error
            id: 'nameCheck',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Name check',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: nameImage,
                      },
                      {
                        width: '*',
                        text: 'Name check',
                        margin: [25, 10, 0, 0],
                      },
                      {
                        width: '*',
                        text: `${documents?.length ?? 0} document(s) checked`,
                        margin: [0, 10, 0, 0],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Checks performed',
                    style: 'containerTableHeader',
                  },
                ],
                [
                  {
                    style: 'breakdownTable',
                    layout: 'greyBordersChild',
                    table: {
                      widths: ['50%', '50%'],
                      body: getCheckDetailsTable(
                        {
                          approved: detailsMatch,
                          results: [
                            {
                              status: 'DONE',
                              recommendation: detailsMatch
                                ? 'Approve'
                                : 'Consider',
                              reason: detailsMatch
                                ? ''
                                : "The name on the user's Further account is not an exact match with the provided identity document.",
                            },
                          ],
                        },
                        'Name check',
                      ),
                    },
                  },
                ],
              ],
            },
          },
          ...(thirdPartyIdentityCheck
            ? [
                {
                  //@ts-expect-error
                  id: 'thirdPartyIdentityCheck',
                  style: 'table',
                  layout: 'greyBorders',
                  table: {
                    widths: ['100%'],
                    body: [
                      [
                        {
                          text: 'Address verification',
                          style: 'tableHeader',
                        },
                      ],
                      [
                        {
                          columns: [
                            {
                              width: 32,
                              image: addressImage,
                            },
                            {
                              width: '*',
                              text: 'Address verification',
                              margin: [25, 10, 0, 0],
                            },
                            {
                              width: '*',
                              text: thirdPartyIdentityCheck?.approved
                                ? 'Approved'
                                : 'Not approved',
                              color: thirdPartyIdentityCheck?.approved
                                ? 'green'
                                : 'orange',
                              margin: [0, 10, 0, 0],
                            },
                          ],
                        },
                      ],
                    ],
                  },
                },
                {
                  style: 'table',
                  layout: 'container',
                  table: {
                    widths: ['100%'],
                    body: [
                      [
                        {
                          text: 'Checks performed',
                          style: 'containerTableHeader',
                        },
                      ],
                      [
                        {
                          style: 'breakdownTable',
                          layout: 'greyBordersChild',
                          table: {
                            widths: ['50%', '50%'],
                            body: getCheckDetailsTable(
                              thirdPartyIdentityCheck,
                              'Address check',
                            ),
                          },
                        },
                      ],
                      ...(addressCheckHasPepOrSanctionsFailure
                        ? [
                            [
                              {
                                text: "If this address check failed for PEP or sanctions reasons, please disregard that failure and consult with the Further system's AML check for accurate results. Address-related PEP and sanctions checks are indicative only.",
                                fontSize: 9,
                                color: '#495566',
                                italics: true,
                                margin: [4, 8, 4, 4],
                                border: [false, false, false, false],
                              },
                            ],
                          ]
                        : []),
                    ],
                  },
                },
              ]
            : []),
          {
            //@ts-expect-error
            id: 'amlCheck',
            style: 'table',
            layout: 'greyBorders',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'AML advanced screening',
                    style: 'tableHeader',
                  },
                ],
                [
                  {
                    columns: [
                      {
                        width: 32,
                        image: eyeImage,
                        margin: [0, 15, 0, 0],
                      },
                      {
                        width: '*',
                        style: 'checkHeaderDetailsLabels',
                        stack: [
                          'Total matches',
                          'Associated country codes',
                          'Client reference',
                          'Search type',
                        ],
                        margin: [25, 0, 0, 0],
                      },
                      {
                        width: '*',
                        style: 'checkHeaderDetails',
                        stack: [
                          getWatchlistSummary(amlCheck?.results ?? [])
                            ?.totalHits ?? '-',
                          getWatchlistSummary(
                            amlCheck?.results ?? [],
                          )?.associatedCountryCodes?.join(', ') ?? '-',
                          getWatchlistSummary(amlCheck?.results ?? [])
                            ?.searchConfig?.clientRef ?? '-',
                          capitalize(
                            getWatchlistSummary(
                              amlCheck?.results ?? [],
                            )?.searchConfig?.sources?.type?.replaceAll(
                              '_',
                              ' ',
                            ) ?? '-',
                          ),
                        ],
                      },
                    ],
                  },
                ],
              ],
            },
          },
          {
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Checks performed',
                    style: 'containerTableHeader',
                  },
                ],
                [
                  {
                    style: 'breakdownTable',
                    layout: 'greyBordersChild',
                    table: {
                      widths: ['50%', '50%'],
                      body: getCheckDetailsTable(
                        amlCheck,
                        'AML advanced screening',
                      ),
                    },
                  },
                ],
              ],
            },
          },
          ...(amlCheck?.results?.map((result) => ({
            style: 'table',
            layout: 'container',
            table: {
              widths: ['100%'],
              body: [
                [
                  {
                    text: 'Advanced search',
                    style: 'containerTableHeader',
                  },
                ],
                ...(Array.isArray(result.watchlistSummary?.rawResults)
                  ? result.watchlistSummary.rawResults.map((rawResult) => [
                      {
                        style: 'table',
                        layout: 'greyBordersChild',
                        table: {
                          widths: ['50%', '50%'],
                          body: [
                            [['Provider'], [rawResult?.provider ?? '-']],
                            [
                              ['URL'],
                              [
                                {
                                  text: rawResult?.url ?? '-',
                                  link: rawResult?.url ?? '-',
                                },
                              ],
                            ],
                          ],
                        },
                      },
                    ])
                  : []),
              ],
            },
          })) ?? []),
        ],
        styles: {
          headerAppInfo: {
            color: '#495566',
            fontSize: 10,
            bold: true,
          },
          footer: {
            color: '#495566',
            fontSize: 10,
            margin: [40, 15, 40, 15],
          },
          table: {
            marginBottom: 15,
            fontSize: 11,
            color: '#495566',
          },
          breakdownTable: {
            fontSize: 11,
            color: '#495566',
          },
          tableHeader: {
            bold: true,
            fontSize: 14,
            color: '#333333',
            fillColor: '#ABB5C0',
            margin: [0, 4, 0, 4],
          },
          containerTableHeader: {
            bold: true,
            fontSize: 14,
            color: '#333333',
            fillColor: '#ABB5C0',
            margin: [16, 4, 16, 4],
          },
          tableSubheader: {
            bold: true,
            fontSize: 13,
            color: '#333333',
          },
          overviewLabel: {
            color: '#495566',
            bold: true,
            marginBottom: 4,
          },
          checkDetails: {
            lineHeight: 1.6,
          },
          checkHeaderDetailsLabels: {
            bold: true,
            lineHeight: 1.4,
          },
          checkHeaderDetails: {
            lineHeight: 1.4,
          },

          header: {
            fontSize: 16,
            bold: true,
          },
          bold: {
            color: '#495566',
            bold: true,
          },
          reasonText: {
            lineHeight: 1,
          },
        },
      },
      {
        greyBorders: {
          hLineColor: () => {
            return '#ABB5C0';
          },
          vLineColor: () => {
            return '#ABB5C0';
          },
          paddingLeft: () => 16,
          paddingRight: () => 16,
          paddingTop: (i) => {
            return i === 0 ? 0 : 8;
          },
          paddingBottom: (i) => {
            return i === 0 ? 0 : 8;
          },
        },
        greyBordersChild: {
          hLineColor: () => {
            return '#ABB5C0';
          },
          vLineColor: () => {
            return '#ABB5C0';
          },
          paddingLeft: () => 16,
          paddingRight: () => 16,
          paddingTop: () => 8,
          paddingBottom: () => 8,
        },
        container: {
          hLineWidth: () => 0,
          vLineWidth: () => 0,
          paddingLeft: () => 0,
          paddingRight: () => 0,
          paddingTop: () => 0,
          paddingBottom: () => 0,
        },
      },
    )
    .download(
      `Further Finance Ltd-${investorDetail?.fullName?.toLowerCase()}-KYC record-${sessionId}`,
    );
};

export default downloadKycPdf;
